var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.locationEnabled)?_c('v-icon',{on:{"click":_vm.checkLocationEnable}},[_vm._v(_vm._s(_vm.mdiMapMarkerCheck))]):_c('v-icon',{on:{"click":_vm.checkLocationEnable}},[_vm._v(_vm._s(_vm.mdiMapMarkerOff))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }